// extracted by mini-css-extract-plugin
export default {"content":"LOxeF","text":"BhUd5","icon":"VmV5B"};